// extracted by mini-css-extract-plugin
export default {"wrapper":"Rj-z","reviewFormSuccess":"Sj-z","header":"Tj-z","message":"Uj-z","paragraph":"Vj-z","lottieContainer":"Wj-z"};